const getTableTokens = (tokens) => {
    return { table: tokens.component.table };
};
const table = (tokens) => {
    const { table } = getTableTokens(tokens);
    return {
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    border: `${table.borderWidth.value} solid ${table.borderColor.value}`,
                    borderRadius: table.borderRadius.value,
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    ".MuiTableCell-root": {
                        paddingLeft: table.header.paddingHorizontal.value,
                        paddingRight: table.header.paddingHorizontal.value,
                        backgroundColor: table.header.backgroundColor.value,
                        borderBottom: 0,
                    },
                    ".MuiTableCell-head": {
                        height: table.header.height.value,
                        color: table.header.color.value,
                        fontSize: table.header.fontSize.value,
                        lineHeight: table.header.lineHeight.value,
                        "&:first-of-type": {
                            paddingLeft: table.header.first.paddingLeft.value,
                        },
                        "&:last-of-type": {
                            paddingRight: table.header.last.paddingRight.value,
                        },
                        "&.MuiTableCell-sizeSmall": {
                            height: table.compact.header.height.value,
                        },
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: table.cell.paddingHorizontal.value,
                    paddingRight: table.cell.paddingHorizontal.value,
                    fontSize: table.cell.fontSize.value,
                    lineHeight: table.cell.lineHeight.value,
                    textAlign: "left",
                    height: table.row.height.value,
                    "&.MuiTableCell-sizeSmall": {
                        height: table.compact.row.height.value,
                    },
                    "&&.MuiTableCell-head": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: 0,
                        border: 0,
                    },
                    "[data-atlas-style-no-zebra-stripes='true'] &": {
                        borderBottom: `${table.borderWidth.value} solid ${table.cell.borderColor.value}`,
                    },
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    th: {
                        paddingLeft: table.cell.first.paddingLeft.value,
                    },
                    "td:first-of-type": {
                        paddingLeft: table.cell.first.paddingLeft.value,
                    },
                    "td:last-of-type": {
                        paddingRight: table.cell.last.paddingRight.value,
                    },
                    "&:hover, &.Mui-selected, &.Mui-selected:hover": {
                        backgroundColor: "inherit",
                    },
                    "&:nth-of-type(even) ": {
                        backgroundColor: table.row.zebraStripe.backgroundColor.value,
                    },
                    "[data-atlas-style-no-zebra-stripes='true'] &": {
                        "&:nth-of-type(even) ": {
                            backgroundColor: "inherit",
                        },
                    },
                },
            },
        },
    };
};
export default table;
//# sourceMappingURL=table.js.map